import { render, staticRenderFns } from "./nuestra-historia.vue?vue&type=template&id=6821ed3f"
import script from "./nuestra-historia.vue?vue&type=script&lang=js"
export * from "./nuestra-historia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports